<footer class="footer-section">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-4 col-12">
        <div class="footer-div">
          <div class="footer-title">
            <img
              id="logoimg"
              src="../../../../../assets/images/White Horizonta.png"
              (click)="Startupweb()"
            />
          </div>
          <div class="footer-details">
            <p class="mb-0">
              Tamil Nadu Startup and Innovation Mission, branded as StartupTN,
              is the Nodal Agency of the Government of Tamil Nadu for Innovation
              and Startups in the State.
            </p>
            <p class="mb-0 mt-3">
              For Further Info Visit
              <a href="https://startuptn.in/" target="_blank" class="text-light"
                >StartupTN.in</a
              >
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-md-5 col-sm-4 col-12">
        <div class="footer-div">
          <div class="footer-title">
            <h5 class="text-light">Contact Details</h5>
          </div>
          <div class="footer-details">
            <ul>
              <li class="footer-address fnt mb-0">
                <p>TamilNadu Startup and Innovation Mission,</p>
                <p>No. 327, CMRL Building,</p>
                <p>10th Floor, Anna Salai, Nandanam,</p>
                <p>Chennai 600 035.</p>
              </li>
              <li class="email-color tab-view mb-0">
                <h4>Email ID -</h4>
                <p class="ml-2 mt-1">incubator@startuptn.in</p>
              </li>
              <li class="mobile-view mt-2">Email ID -incubator@startuptn.in</li>
            </ul>
          </div>
        </div>
      </div>
      <!--Usefull links  -->
      <div class="col-lg-3 col-md-3 col-sm-3 col-12">
        <div class="footer-div">
          <div class="footer-title">
            <h5 class="text-light">Useful Links</h5>
          </div>
          <div class="footer-details" id="footer-usefulllink">
            <ul>
              <li class="d-flex mb-0">
                <a routerLink="/home" (click)="connectIncubator()"
                  >Connect with Incubator
                </a>
              </li>
              <li class="d-flex mb-0">
                <a routerLink="/incubators">Incubators</a>
              </li>
              <li class="d-flex mb-0">
                <a routerLink="/initiatives">Initiatives</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-div">
          <div class="footer-title">
            <h5 class="text-light">Social Media</h5>
          </div>
          <div class="footer-details" style="margin-top: -14px">
            <p class="footer-image" (click)="Linkedinclick()">
              <i class="fab fa-linkedin"></i>
            </p>
            <p class="footer-image" (click)="instaclick()">
              <i class="fab fa-instagram"></i>
            </p>
            <p class="footer-image-fb" (click)="facebookclick()">
              <i class="fab fa-facebook"></i>
            </p>
            <img
              class="footer-image-twit"
              (click)="twiterclick()"
              src="/assets/images/twitter_x_new_logo-2.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
<a id="back-to-top" title="Back to top" style="display: none"
  ><i class="fas fa-arrow-up"></i
></a>
